import config from "clientappsetting.json";

export class ApiUrlResolver {
    static getSettingAPIUrl(countryCode: string): string {
        const settingApiUrl = countryCode == "" ? config.API_URL : config.SETTINGS_API_URL;
        return settingApiUrl;
    }

    static getWebApiUrl(countryCode: string): string {
        const webApiUrl = countryCode == "DK" ? config.API_DK_URL : config.API_URL;
        return webApiUrl;
    }
}